export default {
  pageTitle: {
    id: 'bo_seller.kyb.letter_of_authorization.page_title',
    defaultMessage: 'KYB - Letter of authorization',
  },
  title: {
    id: 'bo_seller.kyb.letter_of_authorization.title',
    defaultMessage: 'Letter of authorization',
  },
  description: {
    id: 'bo_seller.kyb.letter_of_authorization.description',
    defaultMessage:
      "A letter of authorization is required if the account requester doesn't have signatory power. If this is the case, follow these steps to draft and submit a letter of authorization:",
  },
  step1: {
    id: 'bo_seller.kyb.letter_of_authorization.step_1',
    defaultMessage:
      'Consult {templateLink, html} provided by Hyperwallet, the Payment Service Provider.',
  },
  step2: {
    id: 'bo_seller.kyb.letter_of_authorization.step_2',
    defaultMessage: "Use the business's official letterhead.",
  },
  step3: {
    id: 'bo_seller.kyb.letter_of_authorization.step_3',
    defaultMessage:
      'In the letter, grant the account requester the right to act on behalf of the business.',
  },
  step4: {
    id: 'bo_seller.kyb.letter_of_authorization.step_4',
    defaultMessage:
      "Have the letter signed by the business's legal representative.",
  },
  step5: {
    id: 'bo_seller.kyb.letter_of_authorization.step_5',
    defaultMessage: 'Upload the letter of authorization.',
  },
  fileUploadLabelRequired: {
    id: 'bo_seller.kyb.letter_of_authorization.file_upload_label_required',
    defaultMessage: 'This field is required',
  },
  templateLink: {
    id: 'bo_seller.kyb.letter_of_authorization.template_link',
    defaultMessage: 'this template',
  },
  fileUploadLabel: {
    id: 'bo_seller.kyb.letter_of_authorization.file_upload_label',
    defaultMessage: 'Select file',
  },
  fileUploadDescription: {
    id: 'bo_seller.kyb.letter_of_authorization.file_upload_description',
    defaultMessage:
      'Accepted formats: PDF, JPG, JPEG, and PNG. Maximum file size: 5MB.',
  },
  saveButton: {
    id: 'bo_seller.kyb.letter_of_authorization.save_button',
    defaultMessage: 'Save',
  },
  currentDocument: {
    id: 'bo_seller.kyb.letter_of_authorization.current_document',
    defaultMessage: 'Current document',
  },
  saveSuccessTitle: {
    id: 'bo_seller.kyb.letter_of_authorization.save_success',
    defaultMessage: 'Letter of authorization saved successfully',
  },
  saveSuccessContent: {
    id: 'bo_seller.kyb.letter_of_authorization.save_success_content',
    defaultMessage: 'Nice work.',
  },
  saveError: {
    id: 'bo_seller.kyb.letter_of_authorization.save_error',
    defaultMessage: 'Failed to save letter of authorization',
  },
} as const
